import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    selectIsAuthFinished,
    selectOrganizationsLoading,
    selectUserProfile,
    selectWorkingPartyId,
} from '~/src/redux/user/user.selectors';
import { selectIsAuth } from '~/src/redux/id-token/id-token.selectors';

export const useOrganizationsIsLoading = () => {
    const isAuthFinished = useSelector(selectIsAuthFinished);
    const isAuth = useSelector(selectIsAuth);
    const userProfile = useSelector(selectUserProfile);
    const workingPartyId = useSelector(selectWorkingPartyId);
    const organizationsIsLoading = useSelector(selectOrganizationsLoading);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const organizationsIsLoaded =
            isAuth && isAuthFinished && !organizationsIsLoading && workingPartyId;
        const userIsNotAuth = !userProfile.id && isAuthFinished;

        if (organizationsIsLoaded || userIsNotAuth) {
            setIsLoading(false);
        }
    }, [isAuth, isAuthFinished, workingPartyId, organizationsIsLoading, userProfile.id]);

    return isLoading;
};
